import * as yup from 'yup'
export const createJobSchema = yup.object().shape({
    title: yup.string().required('Chưa nhập tên việc làm'),
    type: yup.string().required('Chưa chọn loại việc làm'),
    locale: yup.string().required('Chưa chọn ngôn ngữ'),
    location: yup.string().required('Chưa nhập địa chỉ làm việc'),
    salary: yup.string().required('Chưa nhập mức lương'),
    status: yup.string().required('Chưa chọn trạng thái'),
    categories: yup
        .array()
        .of(yup.number())
        .min(1, 'Phải có ít nhất một loại ngành nghề')
        .required('Chưa chọn loại ngành nghề'),
    // summary: yup.string(),
    // description: yup.string().required('Chưa nhập mô tả'),
    benefit: yup.string().required('Chưa nhập phúc lợi'),
    responsible: yup.string().required('Chưa nhập trách nhiệm công việc'),
    qualification: yup.string().required('Chưa nhập yêu cầu'),
    level: yup.string().required('Chưa nhập yêu cầu công việc'),
    country: yup.string().required('Chưa nhập quốc gia'),
    department: yup.string().required('Chưa chọn phòng ban'),
    // slug: yup.string(),
})
